module.exports = "/assets/data/07ba1d127eea05f64dd83f75578a8732-SY7.data.json";